import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UserCardSelectDropdownComponent as UserCardSelectDropdownComponent } from './dropdown/user-card-select-dropdown.component';

@Component({
    selector: 'app-user-card-select',
    templateUrl: './user-card-select.component.html',
    styleUrls: ['./user-card-select.component.scss'],
})
export class UserCardSelectComponent implements OnInit {
    @Input() label: string;
    @Input() hint: string;
    @Input() disabled = false;
    @Input() placeholder: string;
    @Input() subType: any;
    @Input() form: FormGroup;
    @Input() controlName: string;

    @Input()
    get selected() {
        return this.form.get(this.controlName)?.value;
    }
    set selected(data) {
        this.form.controls[this.controlName].setValue(data);
    }

    @ViewChild(UserCardSelectDropdownComponent)
    public dropdown: UserCardSelectDropdownComponent;

    @Input() options: any[];
    @Output() selectChange = new EventEmitter();

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.cdr.detectChanges();
    }

    get value(): any {
        return this.subType;
    }

    select(option: any) {
        this.selected = option;
        this.selectChange.emit(this.selected);
        this.hideDropdown();
    }

    public toggleDropdown(): void {
        if (this.disabled) {
            return;
        }
        this.dropdown.showing ? this.hideDropdown() : this.showDropdown();
    }

    public showDropdown() {
        this.dropdown.show();
    }

    public hideDropdown() {
        this.dropdown.hide();
    }

    public onTouched: () => void = () => {};
    public OnChange: () => void = () => {};

    writeValue(obj: any): void {
        this.selected = obj;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
